// @flow
type State = {|
  +selectedAudienceId: number
|}

type SelectedAction = {|
  type: 'COPY_AD_TO_AUDIENCE.SELECT',
  id: number
|}

export type { State }

const initialState: State = {
  selectedAudienceId: 0
}

export function select(id: number): SelectedAction {
  return {
    type: 'COPY_AD_TO_AUDIENCE.SELECT',
    id
  }
}

export default function copyAdToAudience(state: State = initialState, action: SelectedAction) {
  switch (action.type) {
    case 'COPY_AD_TO_AUDIENCE.SELECT':
      return { selectedAudienceId: action.id }
    default:
      return state
  }
}
